export default "__VITE_ASSET__Bv292XeS__"